import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DomainHelper from "helpers/DomainHelper";
import axios from "../../utils/axios";
import { RootState } from "../store";
const baseUrl = DomainHelper.getAPIMain()

export interface filtersResponse {
  name: any;
  id: string
}
export interface defaultResponse {
  data: filtersResponse[];
}
interface initialStateProps {
  departaments: filtersResponse[],
  seniorities: filtersResponse[],
  headcount: filtersResponse[],
  revenue: filtersResponse[]

}
const initialState: initialStateProps = {
  departaments: [],
  seniorities: [],
  headcount: [],
  revenue:[] 
}
export const getFilters = createAsyncThunk("filters", async (_: any, thunkAPI) => {
  try {
    const response = await Promise.all([
      axios.get<defaultResponse>(`${baseUrl}filter/departaments`, { withCredentials: true }),
      axios.get<defaultResponse>(`${baseUrl}filter/seniorities`, { withCredentials: true }),
      axios.get<defaultResponse>(`${baseUrl}filter/headcount`, { withCredentials: true }),
      axios.get<defaultResponse>(`${baseUrl}filter/revenue`, { withCredentials: true }),
    ])
    return thunkAPI.fulfillWithValue({
      departaments: response[0].data.data,
      seniorities: response[1].data.data,
      headcount: response[2].data.data,
      revenue: response[3].data.data,
    });
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.message);
  }
});

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    reset: (state) => {
      state.departaments = [];
      state.seniorities = [];
      state.headcount = [];
      state.revenue = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFilters.fulfilled, (state, action) => {
      state.departaments = action.payload.departaments;
      state.seniorities = action.payload.seniorities;
      state.headcount = action.payload.headcount;
      state.revenue = action.payload.revenue;
    });
  },
});